import { render, staticRenderFns } from "./atrativos-layer.vue?vue&type=template&id=4bdbfd6a"
import script from "./atrativos-layer.vue?vue&type=script&lang=js"
export * from "./atrativos-layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports